(function(){
  if (window.SSPromoSliderScriptLoaded) {
    if (window.SSPromoSliderInit) window.SSPromoSliderInit(document);
    return;
  }

  window.SSPromoSliderScriptLoaded = true;

  function initSlider(root) {
    if (!root || root.dataset.promoInitialized === 'true') return;

    const stage = root.querySelector('[data-promo-stage]');
    const prevBtn = root.querySelector('[data-promo-prev]');
    const nextBtn = root.querySelector('[data-promo-next]');
    const countEl = root.querySelector('[data-promo-count]');

    if (!stage) return;

    const slides = Array.from(stage.querySelectorAll('.ss-promo-slide'));
    if (!slides.length) return;

    root.dataset.promoInitialized = 'true';

    let current = 0;
    let autoplay;

    const autoplayEnabled = root.dataset.autoplay === 'true';
    const autoplayInterval = Number(root.dataset.autoplayInterval || 4000);

    function renderSlides() {
      slides.forEach(function(slide, index) {
        slide.classList.toggle('is-active', index === current);
      });

      if (countEl) {
        countEl.textContent = (current + 1) + '/' + slides.length;
      }
    }

    function nextSlide() {
      current = (current + 1) % slides.length;
      renderSlides();
    }

    function prevSlide() {
      current = (current - 1 + slides.length) % slides.length;
      renderSlides();
    }

    function stopAutoplay() {
      if (autoplay) clearInterval(autoplay);
    }

    function startAutoplay() {
      stopAutoplay();

      if (!autoplayEnabled || slides.length <= 1) return;

      autoplay = setInterval(nextSlide, autoplayInterval);
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        nextSlide();
        startAutoplay();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        prevSlide();
        startAutoplay();
      });
    }

    stage.addEventListener('mouseenter', stopAutoplay);
    stage.addEventListener('mouseleave', startAutoplay);
    stage.addEventListener('touchstart', stopAutoplay, { passive: true });
    stage.addEventListener('touchend', startAutoplay);

    renderSlides();
    startAutoplay();
  }

  function initAll(scope) {
    const sliders = scope.querySelectorAll('[data-promo-slider]');
    sliders.forEach(initSlider);
  }

  window.SSPromoSliderInit = initAll;

  document.addEventListener('DOMContentLoaded', function() {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function(event) {
    initAll(event.target);
  });
})();